import { useSelector } from 'react-redux';
import { mainStateSelector, MAIN_STATE_KEY } from './main-reducer';

class MainHelperClass {
  getMasterDataByCode = (code: string) => {
    try {
      const masterdata = useSelector(mainStateSelector(MAIN_STATE_KEY.MASTER_DATA));
      if (masterdata) {
        const val = masterdata.codes[code].classificationNameTh;
        return val;
      } else {
        return code;
      }
    } catch (error) {
      return code;
    }
  }

  getMasterDataByScheme = (scheme: string) => {
    try {
      const masterdata = useSelector(mainStateSelector(MAIN_STATE_KEY.MASTER_DATA));
      if (masterdata) {
        const val = masterdata.schemes[scheme];
        return val;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }
}

export const MainHelper = new MainHelperClass();
